module.exports = __webpack_public_path__ + "static/media/account-pen-name.b4987e70.svg";